module.exports = __webpack_public_path__ + "img/ex-pin-food-drink.327ca656.svg";